import getManifest from './manifest/index';
import { Platform, ComponentAttachmentType } from '@shared/const';
import _get from 'lodash/get';
import Vue from 'vue';
async function createCompScript(manifest = {}) {
  const fragment = document.createDocumentFragment();
  const tasks =  Object.keys(manifest).reduce((acc, key) => {
    if (key.includes('.js.map')) {
      // 过滤sourcemap文件
      return acc;
    }
    const attachmentList = _get(manifest, `[${key}].Attachments`) || [];
    attachmentList.forEach((item = {}) => {
      // 过滤掉yaml类型的附件
      if (item.Type === ComponentAttachmentType.ComponentAttachmentTypeYAML) {
        return;
      }
      const url = item.Content || '';
      // 过滤掉不以http:// 或者 / 开头的值
      if (!(url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/'))) {
        return;
      }
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;

      acc.push(new Promise((resolve, reject) => {
        script.onload = () => {
          // script加载成功后resolve
          resolve();
        };
        script.onerror = (err) => {
          // script加载失败后resolve,不阻塞渲染
          resolve();
          // TODO:日志上报
        };
      }));

      fragment.appendChild(script);
    });

    return acc;
  }, []);
  document.body.appendChild(fragment);
  await Promise.all(tasks);
}

export default async function loadCompScript({
  pageId,
  // 默认加载c端的index.js文件
  platform = Platform.PlatformH5,
} = {}) {
  // 获取manifest
  console.log(getManifest);
  const manifest = await getManifest({
    PageID: pageId,
    platform,
  });
  // 根据manifest组装组件script
  await createCompScript(manifest.Manifest);
}
